import { useEffect, useState } from "react";
import { apiUrl } from "./platform";

type OnlinePlayersState = {
  count: number;
};

// Presence is intentionally a cached snapshot. Keeping a second real-time
// socket open for a decorative count doubled every player's connection cost.
export function useOnlinePlayers(enabled = true): OnlinePlayersState {
  const [state, setState] = useState<OnlinePlayersState>({ count: 1 });

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    void fetch(apiUrl("/api/presence"), {
      headers: { Accept: "application/json" },
      signal: controller.signal
    }).then(async (response) => {
      if (!response.ok) return;
      const payload = await response.json() as { online?: unknown };
      if (typeof payload.online === "number" && Number.isFinite(payload.online)) {
        setState({ count: Math.max(1, Math.floor(payload.online)) });
      }
    }).catch(() => {
      // The count is decorative; gameplay never depends on it.
    });
    return () => controller.abort();
  }, [enabled]);

  return state;
}
